import { useState } from "react";

type Props = {
  title: string;
  content: React.ReactNode;
};

export default function Collaspable(props: Props) {
  const [isOpen, setIsOpen] = useState(true);

  const { title, content } = props;

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="flex flex-col h-full bg-white border border-gray-200 rounded-lg shadow-md">
      <div
        className="flex justify-between items-center p-4 cursor-pointer "
        onClick={toggle}
      >
        <h2 className="text-lg font-medium text-gray-900">{title}</h2>
      </div>
      <div
        className={`flex-grow transition-all duration-300 ${
          isOpen ? "block bg-red-100" : "hidden"
        }`}
      >
        <div className="p-4">{content}</div>
      </div>
    </div>
  );
}
